import dayjs from 'dayjs'

// Locales
import 'dayjs/locale/es'
import 'dayjs/locale/en-gb'
import 'dayjs/locale/fr'
import 'dayjs/locale/de'
import 'dayjs/locale/sv'
import 'dayjs/locale/ar'

// Plugins útiles (similar a moment)
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import duration from 'dayjs/plugin/duration'

dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(duration)

// Configuración global (ej: inglés por defecto)
dayjs.locale('en-gb')

export default defineNuxtPlugin(() => {
  return {
    provide: {
      dayjs
    }
  }
})